import { render, staticRenderFns } from "./PublicCatalogCartDrawer.vue?vue&type=template&id=10cdbcf2&scoped=true&"
import script from "./PublicCatalogCartDrawer.vue?vue&type=script&lang=js&"
export * from "./PublicCatalogCartDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PublicCatalogCartDrawer.vue?vue&type=style&index=0&id=10cdbcf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cdbcf2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VNavigationDrawer})
